import { ReactNode } from 'react';
import * as Sentry from '@sentry/react';

interface Props {
  children: ReactNode;
}

/**
 * Error Boundary using Sentry's built-in ErrorBoundary
 * Catches React component errors and logs them to Sentry silently
 */
const ErrorBoundary = ({ children }: Props) => {
  return (
    <Sentry.ErrorBoundary
      showDialog={false}
      beforeCapture={(scope) => {
        scope.setTag('error_boundary', 'react');
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
